export default __webpack_public_path__ + "static/media/Onion.aad12061.PNG";